
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elections/haryana-assembly/faqs",
      function () {
        return require("private-next-pages/elections/haryana-assembly/faqs/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elections/haryana-assembly/faqs"])
      });
    }
  